import script from "./new-release.vue?vue&type=script&setup=true&lang=js"
export * from "./new-release.vue?vue&type=script&setup=true&lang=js"

import "./new-release.vue?vue&type=style&index=0&id=62ae30bc&scoped=true&lang=less"

import exportComponent from "/Users/xyyw/code/company/web/sanroe-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62ae30bc"]])

export default __exports__